var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 194 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 177.5C136.644 177.5 170 143.986 170 102.5C170 61.0137 136.644 27.5 95.5 27.5C54.356 27.5 21 61.0137 21 102.5C21 143.986 54.356 177.5 95.5 177.5Z",
    fill: "url(#paint0_linear_53_17013)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4982 53.5H146.502C150.766 53.5 154 56.7665 154 61.0724V128.928C154 133.233 150.766 136.5 146.502 136.5H40.4982C36.2345 136.5 33 133.233 33 128.928V61.0724C33 56.7665 36.5286 53.5 40.4982 53.5Z",
    fill: "#384252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 97.3148V130.648C156 134.944 152.606 138.5 148.178 138.5H38.8217C34.5419 138.5 31 134.944 31 130.648V94.5",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.67 78.5H112.251C108.868 78.5 105.632 79.6733 103.131 81.7266L94.1588 89.0599C91.6582 91.1133 88.4222 92.2866 85.0392 92.2866H46.2074C42.236 92.2866 39 95.5133 39 99.4733C39 99.7666 39 100.207 39.1471 100.5L46.3545 138.34C46.9429 141.86 49.8847 144.5 53.5619 144.5H136.668C140.198 144.5 143.287 142.007 143.875 138.487L153.877 86.7133C154.613 82.7533 151.965 79.2333 147.994 78.5C147.405 78.5 146.964 78.5 146.67 78.5Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_53_17013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.386 68.3918H117.607C113.188 68.3918 109.063 69.8648 105.675 72.6635L93.8913 82.2381C90.6507 84.8895 86.379 86.5098 81.9599 86.5098H31.2883C26.1328 86.5098 22.0083 90.7815 22.0083 95.7898C22.0083 96.2317 22.0083 96.6736 22.1556 97.1155L31.4356 146.756C32.1721 151.47 36.1492 154.858 40.7156 154.858H149.129C153.843 154.858 157.673 151.617 158.409 146.903L171.519 78.9975C172.403 73.8419 169.015 69.2756 163.859 68.2445C163.418 68.3918 162.828 68.3918 162.386 68.3918Z",
    fill: "url(#paint1_linear_53_17013)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76 119.5C78.7272 119.5 81 117.454 81 115C81 112.545 78.7272 110.5 76 110.5C73.2727 110.5 71 112.545 71 115C71 117.454 73.2727 119.5 76 119.5Z",
    fill: "#B8C5CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 119.5C115.955 119.5 118 117.227 118 114.5C118 111.773 115.955 109.5 113.5 109.5C111.045 109.5 109 111.773 109 114.5C109 117.379 111.045 119.5 113.5 119.5Z",
    fill: "#B8C5CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9626 84.5C83.6643 74.19 82.4868 61.8181 86.0191 50.6244C89.4041 39.4307 97.4988 29.8572 107.507 24.4077C110.597 22.7875 114.13 21.4619 117.662 21.3146C121.194 21.1673 125.021 22.3456 127.375 25.2913C129.73 27.9425 130.172 32.361 128.259 35.3067C126.198 38.1051 122.077 39.2835 118.692 38.3997C113.247 37.3688 108.831 33.0974 107.507 27.9424C106.182 22.7875 107.948 16.7488 112.069 13.3613C114.718 11.0047 118.398 9.67912 121.783 8.64812C138.266 3.78771 156.222 3.19855 173 6.88068",
    stroke: "#828A99",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99 124.5H90V127.5H99V124.5Z",
    fill: "#B8C5CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.977 3.53668C181.825 5.82509 181.674 7.96086 180.007 8.41854C178.34 8.87622 177.583 7.35065 176.522 5.21481C175.461 3.23152 176.067 1.09568 177.886 0.637998C179.552 0.180317 182.28 0.790596 181.977 3.53668Z",
    fill: "#A0B1BB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.588 13.8236C180.017 11.0388 180.445 9.49165 179.017 8.71808C177.447 7.94452 176.447 9.33699 174.734 11.1935C173.306 12.8954 174.163 15.3707 175.59 16.1443C177.304 17.0726 179.16 16.1443 179.588 13.8236Z",
    fill: "#A0B1BB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.977 9.49615C181.829 10.5752 181.088 11.3459 180.05 11.5C179.605 11.5 179.16 11.5 178.567 11.5C176.492 11.1917 174.861 9.80442 175.009 8.41713C175.158 7.02984 177.085 6.25919 179.457 6.56748C179.902 6.56748 180.346 6.72155 180.643 6.87569C181.533 7.18398 182.126 8.263 181.977 9.49615Z",
    fill: "#474E61"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 50.2158C18 47.7953 18 45.3748 19.5367 44.6629C21.2015 43.951 22.0979 45.6596 23.3784 48.0801C24.531 50.2158 24.0187 52.4938 22.354 53.2057C20.9453 53.9176 18 53.4905 18 50.2158Z",
    fill: "#A0B1BB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.264 37.7695C17.9695 40.838 17.5277 42.5915 19.4421 43.3221C21.3565 44.0527 22.3874 42.4453 24.3018 40.1074C25.7744 38.0617 24.7436 35.4316 22.8291 34.701C20.9147 33.9704 18.5585 35.2855 18.264 37.7695Z",
    fill: "#A0B1BB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17 44.1183C17 42.7884 17.9048 41.7909 18.9604 41.6247C19.4128 41.4584 20.016 41.4584 20.6192 41.6247C23.032 41.7909 25.1432 43.2871 24.9924 44.9495C24.8416 46.6119 22.8812 47.7756 20.3176 47.4431C19.8652 47.4431 19.4128 47.2769 18.9604 47.1106C17.754 46.9444 17 45.6145 17 44.1183Z",
    fill: "#474E61"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44.5C42.6457 44.5 71.553 53.4895 72 86.5",
    stroke: "#828A99",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_53_17013",
    x: 0.00830078,
    y: 57.2445,
    width: 193.651,
    height: 130.613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53_17013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_53_17013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_17013",
    x1: 97.2087,
    y1: 0.303347,
    x2: 95.6723,
    y2: 79.7804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253040",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_17013",
    x1: 96.7843,
    y1: 66.2412,
    x2: 96.7843,
    y2: 155.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D6675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4C5460"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsp);
export default __webpack_public_path__ + "static/media/ESP.8b8b563bfc7385a4caef02c33d34d8e8.svg";
export { ForwardRef as ReactComponent };